
























import { Component, Vue } from 'vue-property-decorator';

import VSelect from '@/components/base/VSelect.vue';
import { sessionStore } from '@/store/session';

@Component({
  components: {
    VSelect,
  },
})
export default class CompanySelect extends Vue {
  private isLoading: boolean = false;

  private companySelected: any = null;

  private companies: any[] = [];

  public getSelectedCompany() {
    return this.companySelected;
  }

  private mounted() {
    this.companies = sessionStore.session?.companies;
    this.companySelected = sessionStore.session?.company;
  }

  private changeSelectedCompany(companySelected: any) {
    sessionStore.setCompany(companySelected);
    this.$emit('change', companySelected);
  }
}
